import { AnnualReportStep } from '@modeso/types__aumico-lib-annualreport-be';

export interface IAumicoDragDropItem {
    id: AnnualReportStep;
    descriptionKey: string;
    fixed?: boolean;
}
